import { FormShape, FormUnit } from "@suse-o11y/signal/form";

import { isShallowEqual } from "~/tools/is-shallow-equal";

import type { DashboardSpec } from "../../../../common/dashboard-spec";

export function initSettingsFormState(spec: DashboardSpec) {
	/**
	 * @owanturist/signal-form does not support `null` as a valid output value
	 * so it has to wrap the output value in an object
	 * TODO drop this wrapper when @owanturist/signal-form supports `null` as a valid output value https://github.com/owanturist/react-impulse/issues/894
	 */
	return FormShape({
		timeRange: FormUnit(spec.timeRange, {
			isInputEqual: isShallowEqual,
			transform: (value) => ({ value }),
		}),
		refreshInterval: FormUnit(spec.refreshInterval, {
			isInputEqual: isShallowEqual,
			transform: (value) => ({ value }),
		}),
		saveVariables: FormUnit(spec.saveVariables),
	});
}

export type SettingsFormState = ReturnType<typeof initSettingsFormState>;
